import PropsType from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import classes from './index.module.scss'

export const GroupNote = ({ title, isI18n, onClickEdit, isShowEdit }) => {
  return (
    <div
      className={`dFlex justifyContentBetween alignItemsCenter ${classes.groupNote}`}
    >
      <Element className="fstItalic">
        {isI18n ? <Translate value={title} /> : title}
      </Element>
      {isShowEdit && (
        <Element
          className={`dFlex justifyContentCenter ${classes.iconEdit} `}
          style={{ color: '#FFFFFF', backgroundColor: '#2C73E8', fontSize: 12 }}
          onClick={onClickEdit}
        >
          <Icon className="icon-edit-square" />
          <Translate value="portfolioScore.edit" />
        </Element>
      )}
    </div>
  )
}

GroupNote.propsType = {
  onClickEdit: PropsType.func,
  title: PropsType.string,
  isI18n: PropsType.bool,
  isShowEdit: PropsType.bool,
}

GroupNote.defaultProps = {
  isI18n: true,
  isShowEdit: false,
}
